<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h4>Assets</h4>
        <base-field addon-left-icon="pound-sign" label="Value of private residence">
          <base-input v-model="value.privateResidence" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Value of other property">
          <base-input v-model="value.otherResidence" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Cash Held (current & saving)">
          <base-input v-model="value.cashHeld" placeholder="cash held" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Investments (shares, bonds etc)">
          <base-input v-model="value.investments" placeholder="investment value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Life policies with value now">
          <base-input v-model="value.lifePolicies" placeholder="life policy value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Personal Effects (cars etc)">
          <base-input v-model="value.personalEffects" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Other Assets">
          <base-input v-model="value.otherAssets" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Total Asset Value">
          <base-input v-model="value.totalAssetValue" readonly />
        </base-field>
      </div>
      <div class="col-md-6">
        <h4>Liabilities</h4>
        <base-field addon-left-icon="pound-sign" label="Residential Loans">
          <base-input v-model="value.residentialLoans" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Other Loans">
          <base-input v-model="value.otherLoans" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Overdrafts">
          <base-input v-model="value.overdrafts" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Guarantees Given">
          <base-input v-model="value.guaranteesGiven" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Credit Cards/HPI/Other">
          <base-input v-model="value.creditCardsHpi" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Tax Owed">
          <base-input v-model="value.taxOwed" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Other Liabilities">
          <base-input v-model="value.otherLiabilities" placeholder="value" :readonly="readonly" />
        </base-field>
        <base-field addon-left-icon="pound-sign" label="Total Liabilities">
          <base-input v-model="value.totalLiabilities" readonly />
        </base-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <base-field addon-left-icon="pound-sign" label="Total Net Worth">
          <base-input v-model="value.totalNetWorth" readonly />
        </base-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssetCalculator',

  props: {
    readonly: { default: false, type: Boolean },
    value: { required: true, type: Object }
  },

  watch: {
    value: {
      handler () {
        this.value.totalAssetValue = new this.$big(this.value.privateResidence || 0)
          .plus(this.value.otherResidence || 0)
          .plus(this.value.cashHeld || 0)
          .plus(this.value.investments || 0)
          .plus(this.value.lifePolicies || 0)
          .plus(this.value.personalEffects || 0)
          .plus(this.value.otherAssets || 0)
          .toFixed(2)

        this.value.totalLiabilities = new this.$big(this.value.residentialLoans || 0)
          .plus(this.value.otherLoans || 0)
          .plus(this.value.bankLoans || 0)
          .plus(this.value.overdrafts || 0)
          .plus(this.value.guaranteesGiven || 0)
          .plus(this.value.creditCardsHpi || 0)
          .plus(this.value.taxOwed || 0)
          .plus(this.value.otherLiabilities || 0)
          .toFixed(2)

        this.value.totalNetWorth = new this.$big(this.value.totalAssetValue || 0)
          .sub(this.value.totalLiabilities || 0)
          .toFixed(2)
      },
      deep: true
    }
  }
}
</script>
